import api from "./core";

const basePath = "api/{{serverSegment}}/Auth";

export default {
  authenticate(credentials) {
    return api.post(`${basePath}`, credentials);
  },
  token(token) {
    return api.token(token);
  },
  refreshToken(token) {
    return api.refreshToken(token);
  },
  forgotPassword(email) {
    return api.put(`${basePath}/RecoverPass`, { email });
  },
  isValidCode(code) {
    return api.get(`${basePath}/IsValidCode/${code}`);
  },
  resetPassword(code, credentials) {
    return api.post(`${basePath}/ResetPassword/${code}`, credentials);
  },
  getCurrentUser() {
    return api.get(`${basePath}/CurrentUser`);
  },
  twoFactorAuth(credentials) {
    return api.post(`${basePath}/TfaAuth`, credentials);
  }
};
